var bighouse = bighouse || {};

bighouse.mailchimpNewsletter = (function () {

    var localUrl = window.apiUrl;
    if (typeof window.apiUrl === 'undefined' || window.apiUrl === null) {
        localUrl = 'https://big-house-experience-live.azurewebsites.net/';
    }

    const formId = '#newsletter-signup';
    const formFeedback = '.Newsletter-message-description';
    const emailValidationRegEx = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const newsletterApi = localUrl + 'umbraco/api/NewsletterSubscription/Subscribe';

    const emailError = 'A valid email address is required.';
    const apiErrorHTTP = 'There was a problem. Please try again.';
    const apiSuccess = "Success! You've been added to our newsletter.";


    function init() {
        if( $( formId ).length === 0  )
            return;

        bindEvents();
    }

    function bindEvents() {
        const form = $(formId);
        $( formId ).submit(function( e ) {
            e.preventDefault();
            processForm(form);
        });
    }

    //Validate email address against regular expression
    function isEmail(email) {
        return emailValidationRegEx.test(email);
    }

    //Check email address and pass to register() for AJAX submission
    //TODO: Else should be added to validation and the user should be notified of an invalid email address
    function processForm(form) {

        showLoading();
        removeError();

        if(isEmail($(form).find('#mce-EMAIL').val())){
            register(form);
        } else {
            showError(emailError);
        }
    }

    function showError(errorMsg){
        removeSuccess();
        $(formId).find(formFeedback).html(errorMsg);
        $(formId).addClass('Newsletter--error');
        removeLoading();
    }

    function removeError(){
        $(formId).removeClass('Newsletter--error');
    }


    function showSuccess(message){
        removeError();
        $(formId).find(formFeedback).html(message);
        $(formId).addClass('Newsletter--success');
        removeLoading();
    }

    function removeSuccess(){
        $(formId).removeClass('Newsletter--success');
    }


    function showLoading(){
        $(formId).addClass('Newsletter--loading');
        $(formId).find('input[type="email"]').prop('readonly', true);
        $(formId).find('input[type="submit"]').prop('disabled', true);
    }

    function removeLoading(){
        $(formId).removeClass('Newsletter--loading');
        $(formId).find('input[type="email"]').removeAttr('readonly');
        $(formId).find('input[type="submit"]').removeAttr('disabled');
    }


    //Submit form via Ajax to mailchimp. Mailchimp credentials are taken from the <form> action and method. 
    //data is retreived from the HTML form. Form markup is provided by mailchimp. The name & id's are important.
    //Using JSONP as the datatype to bypass CORS. jsonp: c represents the mailchimp callback
    //TODO: status callbacks (error, success) need to be updated to reflect the markup decisions. 
    function register(form) {    
        $.ajax({
            type: 'POST',
            url: newsletterApi,
            data: form.serialize(),
            error: function(err) {
                //If there's an error making the HTTP request this function will be called.  
                showError(apiErrorHTTP);
                console.log(err); 
            },
            success: function(data) {
                showSuccess(apiSuccess);
                bighouse.formSubmissionEventTracking.formSubmissionEvent("newsletter");
            }
        });
    }

    return {
        init: init
    };
})();